module.exports = __webpack_public_path__ + "img/down-w.9b652d67.svg";